import {
  StyleSheet,
  Image,
  FlatList,
  Text,
  View,
  useWindowDimensions,
} from "react-native";
import { Entypo } from "@expo/vector-icons";
import { ScrollView, TouchableOpacity } from "react-native-gesture-handler";
import RenderHtml from "react-native-render-html";
import image from "../../assets/picture2.png";
import {source} from "./data";
import { SafeAreaView } from "react-native";
import { Accordion } from "../colaps/Accordion";
import { StatusBar } from "react-native";
// import { dataa } from "../dataa";

const AmharicPage = (props) => {
  const data = source();
  const { width } = useWindowDimensions();

  const renderItem = ({ item }) => {
    return <Accordion item={item} />;
  };

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar
        barStyle="light-content"
        hidden={false}
        backgroundColor="#192655"
        translucent={false}
        networkActivityIndicatorVisible={true}
        animated={true}
      />
      <View style={styles.header}>
        <TouchableOpacity onPress={() => props.navigation.goBack()}>
          <Entypo name="chevron-left" color="#fff" size={25} />
        </TouchableOpacity>
        {/* <Entypo name="chevron-left" color="#FFF" size={25} /> */}
      </View>

      <View style={styles.cont3}>
        {/* <ScrollView
          style={{ flex: 1 }}
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}
        > */}
          <FlatList
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}
            data={data}
            keyExtractor={(item, index) => `${item.title}${index}`}
            renderItem={renderItem}
          />

          {/* <RenderHtml
            contentWidth={width}
            source={source}
            renderersProps={renderersProps}
          /> */}
        {/* </ScrollView> */}
      </View>
    </SafeAreaView>
  );
};

export default AmharicPage;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#192655",
  },
  title: {
    fontSize: 25,
    marginTop: 30,
  },
  subtitle: {
    fontSize: 20,
    color: "#474747",
    marginTop: 10,
  },
  text: {
    fontSize: 18,
    paddingRight: 80,
    lineHeight: 25,
  },
  btn: {
    backgroundColor: "#E2443B",
    paddingHorizontal: 60,
    paddingVertical: 12,
    borderRadius: 30,
  },
  btnText: {
    fontSize: 20,
    color: "#FFF",
  },
  cont1: {
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between",
    marginTop: 40,
  },
  c3: {
    height: 20,
    width: 20,
    borderRadius: 5,
    backgroundColor: "#529CC0",
  },
  c2: {
    height: 20,
    width: 20,
    borderRadius: 5,
    backgroundColor: "#529C47",
    marginHorizontal: 10,
  },
  c1: {
    height: 20,
    width: 20,
    borderRadius: 5,
    backgroundColor: "#E2443B",
  },
  selected: {
    borderColor: "#E2443B",
    height: 30,
    width: 30,
    borderRadius: 5,
    borderWidth: 2,
    alignItems: "center",
    justifyContent: "center",
  },
  cont2: {
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    marginVertical: 25,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    paddingHorizontal: 20,
    paddingTop: 20,
  },
  img: {
    height: "45%",
    width: "50%",
  },
  cont3: {
    marginTop: 20,
    flex: 1,
    backgroundColor: "#FFF",
    width: "100%",
    // borderRadius: 5,
    // paddingHorizontal: 20,
  },
});
